/**
 * Shows the floating back-to-top button once the page has scrolled past a
 * threshold, and scrolls to top on click. One instance, rendered globally in
 * theme.liquid — the threshold means it never appears on a page short enough
 * not to need it.
 *
 * Horizon's page-transition layout (layout/theme.liquid) scrolls an inner
 * `.page-wrapper` div rather than the document — `window.scrollY` stays 0
 * even at the bottom of a long page — so that's the element this listens to
 * and scrolls, falling back to window if it's ever absent.
 */
const SHOW_AFTER_PX = 600;

class BricklineBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.brickline-back-to-top__button');
    if (!this.button) return;

    this.scroller = document.querySelector('.page-wrapper') || window;

    this.#onScroll();
    this.scroller.addEventListener('scroll', this.#onScroll, { passive: true });
    this.button.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.#onScroll);
    this.button?.removeEventListener('click', this.#onClick);
  }

  #onScroll = () => {
    const scrollTop = this.scroller === window ? window.scrollY : this.scroller.scrollTop;
    this.button.classList.toggle('is-visible', scrollTop > SHOW_AFTER_PX);
  };

  #onClick = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scroller.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };
}

if (!customElements.get('brickline-back-to-top')) {
  customElements.define('brickline-back-to-top', BricklineBackToTop);
}
